export default (common, resolve) => async productName => {
  const regex = new RegExp(`/(${productName}).(js)$`);
  const path = resolve.keys().find(filePath => regex.test(filePath));
  const productConstants = path ? await resolve(path) : {};

  return Object.assign(
    {},
    common,
    productConstants,
  );
};
